import {charcoal} from '../../sass/v2/_exports.sass';
import {getColors} from '../../utils/styles';

const colors = getColors();

export const ErrorCircleIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {
    height: `${ratio * height}px`,
    width: `${ratio * width}px`,
  };

  const colorValue = (colors[color] as string) || charcoal;

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Error"
    >
      <path
        d="M15.9373 2.66667C8.62 2.66667 2.66666 8.64801 2.66666 16C2.66666 23.352 8.648 29.3333 16 29.3333C23.352 29.3333 29.3333 23.352 29.3333 16C29.3333 8.64801 23.324 2.66667 15.9373 2.66667ZM16 26.6667C10.1187 26.6667 5.33333 21.8813 5.33333 16C5.33333 10.1187 10.0893 5.33334 15.9373 5.33334C21.8547 5.33334 26.6667 10.1187 26.6667 16C26.6667 21.8813 21.8813 26.6667 16 26.6667Z"
        fill={colorValue}
      />
      <path
        d="M14.6667 9.33334H17.3333V18.6667H14.6667V9.33334ZM14.6667 20H17.3333V22.6667H14.6667V20Z"
        fill={colorValue}
      />
    </svg>
  );
};
